import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@yotpo-ui/core';

@Injectable()
export class MonitorService {
  constructor(private authenticationService: AuthService, private route: ActivatedRoute) { }

  reportError(error, type, source, additionalAttributes = {}) {
    if (window['newrelic'] !== undefined) {
      let err = new Error(error);
      let appKey = this.authenticationService.getCredentials().appKey || this.route.snapshot.queryParams['app_key'] || this.route.snapshot.queryParams['appkey'];
      let shop_domain = this.route.snapshot.queryParams['shop_domain'] || this.route.snapshot.queryParams['shopDomain'];

      let baseAttributes = {  appKey: appKey,
        shopDomain: shop_domain,
        pageAddress: window.location.href.split('?')[0],
        errorType: type,
        errorSource: source,
      };
      window['newrelic'].noticeError(err, { ...baseAttributes, ...additionalAttributes });
    }
  }
}
